export const commonOptions = {
  grid: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'none'
    },
    backgroundColor: 'rgba(0,0,0,0.7)',
    textStyle: {
      fontSize: 12
    }
  }
};
